module.exports = __webpack_public_path__ + "img/logo-saml.0f39c478.png";